import axios from 'axios'
import { Message } from 'element-ui'
import { getToken, removeToken } from './auth'
import router from '@/router'

const request = axios.create({
  baseURL: '/api',
  timeout: 15000
})

export function initRequest() {
  request.interceptors.request.use(config => {
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  }, error => Promise.reject(error))

  request.interceptors.response.use(response => {
    const res = response.data
    if (res.code !== 200) {
      // 401 未登录，跳转登录页
      if (res.code === 401 || res.code === 403) {
        Message.error(res.message || '请重新登录')
        removeToken()
        if (router.currentRoute.path !== '/login') {
          router.push('/login')
        }
        return Promise.reject(new Error(res.message))
      }
      Message.error(res.message || '请求失败')
      return Promise.reject(new Error(res.message))
    }
    return res
  }, error => {
    Message.error(error.message || '网络错误')
    return Promise.reject(error)
  })
}

export default request